export const CONFIG = "konfiguration"
export const DOMAIN = "domain"
export const CLIENTDATA = "kundendaten"
export const PAYMENT = "zahlungsart"
export const SUMMARY = "bestellübersicht"
export const STANDALONE = "iframe"

export const OUTSOURCING_TARGET = "ausgliederung-ziel"
export const OUTSOURCING_RECOMMEND = "ausgliederung-empfehlung"


export const PRODUCT_SELECTION = "produkt-auswahl"
export const PRODUCT_CHANGE = "produkt-wechsel"
//export const ACCESSORY_ADD = "addon-bestellen"



/** WEBPACK FOOTER **
 ** ./src/constants/StepLabels.js
 **/